/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_mobile_analytics_app_id": "ff02371c23394cca90aa97b3192a71ff",
    "aws_mobile_analytics_app_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-north-1:9dcef06c-b0b1-4745-bfcd-03c68cbd4fd5",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_fR35FyWx8",
    "aws_user_pools_web_client_id": "2bssb2ljclb1n6u0nl9g9hir4u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
